module.exports = __webpack_public_path__ + "static/media/4-1.12a27a4f.mp3";